export type FreightVersionOrderSummary = {
  affectedOrderCount?: unknown;
  pendingOrderCount?: unknown;
};

export const getFreightVersionOrderCount = (value: unknown) => {
  const count = Number(value);

  if (!Number.isFinite(count) || count <= 0) return 0;

  return Math.trunc(count);
};

export const canApplyFreightVersion = (
  version: FreightVersionOrderSummary,
  canEdit: boolean,
) =>
  canEdit && getFreightVersionOrderCount(version.pendingOrderCount) > 0;
